import { createFileRoute } from "@tanstack/react-router";
import { AppShellSkeleton } from "@/components/custom/app-shell-skeleton";
import {
  IncompleteUrlFallback,
  OrgProjectErrorFallback,
} from "@/lib/org-project-context/error-fallbacks";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects"
)({
  pendingComponent: AppShellSkeleton,
  errorComponent: OrgProjectErrorFallback,
  notFoundComponent: IncompleteUrlFallback,
});
